import { useState } from 'react';
import { Outlet } from '@tanstack/react-router';
import Sidebar from './Sidebar';
import HeaderBar from './HeaderBar';

export default function Layout() {
  const [navOpen, setNavOpen] = useState(false);

  return (
    <div className="flex h-full pl-safe pr-safe">
      <Sidebar open={navOpen} onClose={() => setNavOpen(false)} />
      <main className="flex-1 flex flex-col min-w-0">
        <HeaderBar onMenuClick={() => setNavOpen(true)} />
        <div className="flex-1 overflow-auto p-4 sm:p-6 pb-safe">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
